import { inputInitState } from "./init_state";
import * as ActionTypes from "../actions/action_type";

const initialStete = {
  stores: {
    data: inputInitState,
  },
};
export const postpone_view_info = (state = initialStete, action) => {
  switch (action.type) {
    case ActionTypes.getPostponeViewSuccessAction: {
      return { ...state, stores: action.payload };
    }
    case ActionTypes.getPostponeViewFailAction:
    case ActionTypes.getPostponeViewResetAction:
      return { ...state, stores: initialStete.stores };
    default:
      return state;
  }
};
